import React from 'react';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
function VisaLogo() {
  return <div className="bg-white border border-gray-200 rounded-md px-3 py-2 flex items-center justify-center min-w-[60px] h-10 shadow-sm" data-id="element-433">
      <span className="font-extrabold italic text-[#1A1F71] text-lg tracking-tight" data-id="element-434">
        VISA
      </span>
    </div>;
}
function MastercardLogo() {
  return <div className="bg-white border border-gray-200 rounded-md px-3 py-2 flex items-center justify-center gap-0 min-w-[60px] h-10 shadow-sm" data-id="element-435">
      <span className="w-5 h-5 rounded-full bg-[#EB001B] -mr-1.5" data-id="element-436"></span>
      <span className="w-5 h-5 rounded-full bg-[#F79E1B] opacity-90 mix-blend-multiply" data-id="element-437"></span>
    </div>;
}
function AmexLogo() {
  return <div className="bg-[#006FCF] border border-[#006FCF] rounded-md px-3 py-2 flex items-center justify-center min-w-[60px] h-10 shadow-sm" data-id="element-438">
      <span className="font-extrabold text-white text-[10px] leading-tight text-center tracking-tight" data-id="element-439">
        AMERICAN
        <br data-id="element-440" />
        EXPRESS
      </span>
    </div>;
}
function PayPalLogo() {
  return <div className="bg-white border border-gray-200 rounded-md px-3 py-2 flex items-center justify-center min-w-[60px] h-10 shadow-sm" data-id="element-441">
      <span className="font-extrabold italic text-lg leading-none" data-id="element-442">
        <span className="text-[#003087]" data-id="element-443">Pay</span>
        <span className="text-[#009CDE]" data-id="element-444">Pal</span>
      </span>
    </div>;
}
function MercadoPagoLogo() {
  return <div className="bg-[#00B1EA] border border-[#00B1EA] rounded-md px-3 py-2 flex items-center justify-center min-w-[60px] h-10 shadow-sm" data-id="element-445">
      <span className="font-extrabold text-white text-[10px] leading-tight text-center tracking-tight" data-id="element-446">
        mercado
        <br data-id="element-447" />
        pago
      </span>
    </div>;
}
function ApplePayLogo() {
  return <div className="bg-black border border-black rounded-md px-3 py-2 flex items-center justify-center gap-1 min-w-[60px] h-10 shadow-sm" data-id="element-448">
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-white" aria-hidden="true" data-id="element-449">
        <path d="M17.5 12.5c0-2.5 2-3.7 2.1-3.8-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.6.9-.8 0-1.9-.9-3.1-.8-1.6 0-3.1.9-3.9 2.4-1.7 2.9-.4 7.2 1.2 9.6.8 1.2 1.7 2.5 3 2.4 1.2-.1 1.7-.8 3.1-.8s1.9.8 3.1.7c1.3 0 2.1-1.2 2.9-2.4.9-1.4 1.3-2.7 1.3-2.8-.1 0-2.6-1-2.6-3.5zM15.1 5.3c.7-.8 1.1-1.9 1-3-.9.1-2.1.6-2.7 1.4-.6.7-1.2 1.8-1 2.9 1 .1 2-.5 2.7-1.3z" data-id="element-450" />
      </svg>
      <span className="font-bold text-white text-xs" data-id="element-451">Pay</span>
    </div>;
}
function GooglePayLogo() {
  return <div className="bg-white border border-gray-200 rounded-md px-3 py-2 flex items-center justify-center gap-1 min-w-[60px] h-10 shadow-sm" data-id="element-452">
      <span className="font-extrabold text-xs leading-none" data-id="element-453">
        <span className="text-[#4285F4]" data-id="element-454">G</span>
        <span className="text-[#EA4335]" data-id="element-455">o</span>
        <span className="text-[#FBBC04]" data-id="element-456">o</span>
        <span className="text-[#4285F4]" data-id="element-457">g</span>
        <span className="text-[#34A853]" data-id="element-458">l</span>
        <span className="text-[#EA4335]" data-id="element-459">e</span>
      </span>
      <span className="font-bold text-gray-700 text-xs" data-id="element-460">Pay</span>
    </div>;
}
export function TrustBadges() {
  return <section className="w-full py-10 md:py-12 bg-[#FBF7F0] border-y border-[#3E2723]/10" data-id="element-461">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-462">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 text-center" data-id="element-463">
          <div className="flex flex-col items-center gap-2" data-id="element-464">
            <Lock className="w-7 h-7 text-[#14B8A6]" data-id="element-465" />
            <div className="text-sm font-bold text-[#3E2723]" data-id="element-466">
              SSL Encrypted
            </div>
            <div className="text-xs text-[#3E2723]/60" data-id="element-467">Secure Checkout</div>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-468">
            <CreditCard className="w-7 h-7 text-[#14B8A6]" data-id="element-469" />
            <div className="text-sm font-bold text-[#3E2723]" data-id="element-470">
              All Major Cards
            </div>
            <div className="text-xs text-[#3E2723]/60" data-id="element-471">
              Visa · Mastercard · Amex
            </div>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-472">
            <Zap className="w-7 h-7 text-[#14B8A6]" data-id="element-473" />
            <div className="text-sm font-bold text-[#3E2723]" data-id="element-474">
              Instant Access
            </div>
            <div className="text-xs text-[#3E2723]/60" data-id="element-475">
              Delivered to your email
            </div>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-476">
            <ShieldCheck className="w-7 h-7 text-[#14B8A6]" data-id="element-477" />
            <div className="text-sm font-bold text-[#3E2723]" data-id="element-478">
              30-Day Guarantee
            </div>
            <div className="text-xs text-[#3E2723]/60" data-id="element-479">100% Risk-Free</div>
          </div>
        </div>

        <div className="border-t border-[#3E2723]/10 mt-8 pt-8" data-id="element-480">
          <div className="text-xs uppercase tracking-[0.25em] text-[#3E2723]/60 font-bold text-center mb-5" data-id="element-481">
            We Accept
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4" data-id="element-482">
            <VisaLogo data-id="element-483" />
            <MastercardLogo data-id="element-484" />
            <AmexLogo data-id="element-485" />
            <PayPalLogo data-id="element-486" />
            <ApplePayLogo data-id="element-487" />
            <GooglePayLogo data-id="element-488" />
          </div>
        </div>
      </div>
    </section>;
}